'use strict';
// Test (material sample test definition) workspace.
module.exports = {
	Identifier: 'TestWorkspace', Ordinal: 243,
	Entity: { Name: 'Test', IDField: 'IDTest', Collection: 'Tests', GUIDField: 'GUIDTest' },
	Header: { Eyebrow: 'Test', Title: (r) => r.Name || `Test ${r.IDTest}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Test/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'labs', Label: 'Labs', Icon: 'fas fa-flask', Content: { kind: 'assoc', ref: 'LabTest' } },
		{ Key: 'specsets', Label: 'Specification Sets', Icon: 'fas fa-vials', Content: { kind: 'assoc', ref: 'TestTestSpecificationSet' } },
		{ Key: 'requirements', Label: 'Requirements', Icon: 'fas fa-list-check', Content: { kind: 'childlist', ref: 'TestSpecificationRequirement', parentField: 'IDTest',
			columns: [ { Key: 'Name', Label: 'Name' } ], empty: 'No requirements defined for this test.' } },
		{ Key: 'instances', Label: 'Test Instances', Icon: 'fas fa-microscope', Content: { kind: 'childlist', ref: 'TestInstance', parentField: 'IDTest',
			columns: [ { Key: 'Name', Label: 'Name' }, { Key: 'Status', Label: 'Status' }, { Key: 'SampleTestNumber', Label: 'Test #' } ], empty: 'No test instances yet.', cap: 200 } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'Description', Label: 'Description', Wide: true } ] } ],
};
